import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useFirebase } from 'react-redux-firebase'
import { compose } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { withRouter } from 'react-router'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Divider from '@material-ui/core/Divider'
import { Link } from 'react-router-dom'
import { get } from 'lodash'
import Type from '../Type'
import L from '../L'
import IconSupport from '../../Icons/IconSupport'
import IconAccount from '../../Icons/IconAccount'
import { ENVIRONMENT, SUPPORT } from '../../Config'
import { navMenuStyles, StyledMobileIcon, styledMenuItemStyles } from './NavMenu-styles'

export const StyledMenu = withStyles(() => ({
  paper: {
    maxWidth: '100%',
    boxShadow: '0 9px 13px -7px rgba(0, 0, 0, .32)',
    whiteSpace: 'normal',
    marginLeft: -1,
  },
}))(props => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    PopoverClasses={{ root: 'remove-z' }}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))

export const StyledMenuItem = withStyles(styledMenuItemStyles)(MenuItem)

const enhance = compose(withRouter, withStyles(navMenuStyles))

const NavMenu = props => {
  const firebase = useFirebase()
  const auth = useSelector(({ firebase }) => firebase.auth)
  const account = useSelector(({ account }) => account)
  const scopes = get(account, 'claims.available_scopes') ? account.claims.available_scopes.split(' ') : []

  const [anchorEl, setAnchorEl] = useState(null)
  const [isOpen, setIsOpen] = useState(false)
  const isAuthor = scopes.includes('author')
  const isReviewer = scopes.includes('reviewer')
  const dropdownWidth = 0

  function handleClick(event) {
    if (window.innerWidth < 1024) {
      document.getElementById('nav-menu').style.width = `100%`
      document.getElementById('nav-menu').style.marginLeft = `-15px`
    } else {
      document.getElementById('nav-menu').style.width = `${Math.max(event.currentTarget.offsetWidth, 175)}px`
      document.getElementById('nav-menu').style.marginLeft = `0px`
    }
    !isOpen ? setAnchorEl(event.currentTarget) : setAnchorEl(null)
    setIsOpen(!isOpen)
  }

  function handleClose() {
    setAnchorEl(null)
    setIsOpen(false)
  }

  function handleLogout() {
    firebase
      .auth()
      .signOut()
      .then(() => {
        props.history.push(`/`)
      })
      .catch(error => {
        props.history.push(`/`)
        console.warn('sign out error', error)
      })
  }

  const renderMenu = () => (
    <StyledMenu
      id="nav-menu"
      className="menu--add-shadow"
      anchorEl={anchorEl}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      style={{ width: `${dropdownWidth}px` }}
    >
      <L pT={{ xx: 0.8, md: 1.8 }} pB={1}>
        {/* <Link variant={'body2'} to="/">
          <StyledMenuItem>View Instructions Page</StyledMenuItem>
        </Link> */}
        <L display={{ md: 'none' }}>
          <StyledMenuItem className="menu-item--neutral">{auth.email}</StyledMenuItem>
        </L>
        {isAuthor || isReviewer ? (
          <Link variant="body2" to="/">
            <StyledMenuItem
              className={['menu-item--secondary', props.location.pathname === '/' ? 'active' : ''].join(' ')}
            >
              Dashboard
            </StyledMenuItem>
          </Link>
        ) : null}
        {ENVIRONMENT === 'dev' ? (
          <Link variant="body2" to="/marketing-experience">
            <StyledMenuItem
              className={[
                'menu-item--secondary',
                props.location.pathname === '/marketing-experience' ? 'active' : '',
              ].join(' ')}
            >
              Marketing Experience
            </StyledMenuItem>
          </Link>
        ) : null}
        {isAuthor || isReviewer ? (
          <Link variant="body2" to="/assemble">
            <StyledMenuItem
              className={['menu-item--secondary', props.location.pathname === '/assemble' ? 'active' : ''].join(' ')}
            >
              Assemble
            </StyledMenuItem>
          </Link>
        ) : null}
        <div onClick={handleLogout} onKeyDown={handleLogout} style={{ outline: 'none' }}>
          <Type variant="body2">
            <StyledMenuItem className="menu-item--secondary">Logout</StyledMenuItem>
          </Type>
        </div>
      </L>
      <Divider light />
      <a href={SUPPORT} target="_blank" rel="noreferrer">
        <StyledMenuItem className="menu-item--secondary">
          <L display="grid" gap={1} flow="column" ai="center" jc="flex-start" color="secondaryHueLightish">
            <IconSupport />
            <Type variant="subtitle">Support</Type>
          </L>
        </StyledMenuItem>
      </a>
    </StyledMenu>
  )

  return (
    <div className={`${props.classes.navMenu} ${props.customClass} ${isOpen ? 'is-open' : ''}`}>
      <StyledMobileIcon active={isOpen} onClick={handleClick}>
        <IconAccount color={isOpen ? '#E11C8E' : '#033691'} />
      </StyledMobileIcon>
      <L display={{ xx: 'none', md: 'block' }}>
        <div
          className={props.classes.navMenuHead}
          aria-controls="nav-menu"
          aria-haspopup="true"
          onClick={handleClick}
          onKeyDown={handleClick}
        >
          <Type variant="body2" color="secondary">
            {auth.email}
          </Type>
          <div className={[props.classes.navMenuHeadIcon, isOpen ? 'active' : ''].join(' ')} />
        </div>
      </L>
      {renderMenu()}
    </div>
  )
}

export default enhance(NavMenu)
